module.exports = __webpack_public_path__ + "img/27.fb7c0051.png";